// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"47":"8ae3e7f3e805246e95c4","160":"b31b1040659cc86d5576","384":"e9943ae83586bacdc37a","747":"4f6e8587cc5e90a72afc","894":"c88d76ce26f8507e49fb"}[chunkId] + ".js";
};